import { toJalaali } from 'jalaali-js';

function convertGregorianToShamsi(gregorianDate: string): string {
  const [gregorianYear, gregorianMonth, gregorianDay] = gregorianDate
    .split('-')
    .map(Number);

  if (
    isNaN(gregorianYear) ||
    isNaN(gregorianMonth) ||
    isNaN(gregorianDay) ||
    gregorianMonth < 1 ||
    gregorianMonth > 12 ||
    gregorianDay < 1 ||
    gregorianDay > 31
  ) {
    throw new Error('Invalid Gregorian date');
  }

  const shamsiDate = toJalaali(gregorianYear, gregorianMonth, gregorianDay);

  const formattedShamsiDate = `${shamsiDate.jy}/${String(shamsiDate.jm).padStart(2, '0')}/${String(shamsiDate.jd).padStart(2, '0')}`;

  return formattedShamsiDate;
}

export default convertGregorianToShamsi;
